/**
 * Shared constants for the client application
 */

// API Configuration
export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || 'http://localhost:4000';

// Validation Patterns
export const POSTAL_CODE_PATTERN = /^[A-Z][0-9][A-Z][0-9][A-Z][0-9]$/;
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Scroll Configuration
export const SCROLL_TOLERANCE = 1; // For rounding tolerance in scroll calculations
export const COLUMN_GAP = 100; // Gap between footer columns in pixels

// Form Validation
export const MIN_PASSWORD_LENGTH = 6;
export const MAX_POSTAL_CODE_LENGTH = 7;

// UI Constants
export const DEFAULT_COLUMNS_COUNT = 6;
export const SMOOTH_SCROLL_BEHAVIOR = 'smooth' as ScrollBehavior;

/**
 * Social Media Links, taken off the dank.ca footer.
 *
 * Only the networks Dank actually runs are listed. The old placeholders here
 * pointed at youtube.com / twitter.com homepages, which rendered as icons that
 * went nowhere. Add a key back only once the account exists, the footer skips
 * anything that isn't set.
 */
export const SOCIAL_LINKS: Partial<Record<'instagram' | 'facebook' | 'youtube' | 'twitter' | 'tiktok', string>> = {
  instagram: 'https://www.instagram.com/wholelottadank/',
  facebook: 'https://www.facebook.com/wholelottadank/',
};

// Footer Configuration
export const FOOTER_COLUMN_CLASS = 'footer-column';

// Category slug mappings: database value -> URL slug
export const CATEGORY_SLUG_MAP: Record<string, string> = {
  "Flower": "flower",
  "Pre-Roll": "pre-roll",
  "Extract": "extract",
  "Edible": "edible",
  "Beverage": "beverage",
  "Topical": "topical",
  "Accessory": "accessory",
  "Vape": "vape",
  "Capsule": "capsule",
  "Tincture": "tincture",
  "Patch": "patch",
  "Suppository": "suppository",
  "Seed": "seed",
  "Device": "device",
} as const;

// Reverse mapping: URL slug -> database value
export const CATEGORY_SLUG_REVERSE_MAP: Record<string, string> = Object.fromEntries(
  Object.entries(CATEGORY_SLUG_MAP).map(([db, slug]) => [slug, db])
);










